import { PASSWORD_REGEX_ANTI } from '../constants/regex';

export const validatePassword = (password: string) => {
  let message = '';
  if (password.length === 0) return true;

  // Check length
  if (password.length < 12) {
    message = `Must be 12+ characters (you entered ${password.length})`;
    return message;
  }

  // Check has number
  if (!/\d/.test(password)) {
    message = 'Must contain at least one number';
    return message;
  }

  // Check has lowercase
  if (!/[a-z]/.test(password)) {
    message = 'Must contain at least one lowercase letter';
    return message;
  }

  // Check has uppercase
  if (!/[A-Z]/.test(password)) {
    message = 'Must contain at least one uppercase letter';
    return message;
  }

  // Check what they did for invalid characters
  const invalidChars = new Set(
    [...password.trim().matchAll(PASSWORD_REGEX_ANTI)].map((a) => a[0])
  );
  if (invalidChars.size > 0) {
    message = `Cannot use ${[...invalidChars].join(' ')}`;
    return message;
  }

  return message;
};
